var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["chat-received-attachment"] },
    [
      _c("lightbox", {
        attrs: {
          options: { rel: "lightbox[right]" },
          images: [
            {
              src: _vm.attachment.attachment.url,
              thumb: _vm.attachment.attachment.thumburl,
              rel: "lightbox[right]"
            }
          ],
          id: _vm.index.toString()
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }